import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useConfirmationDialogue } from '../../providers/ConfirmationDialogue.provider';
import { PartnerAccountPermissionsValue } from '../useApi/usePostPartnerAccountPermissions';

const usePermissionUpdateDialogue = (response: PartnerAccountPermissionsValue): { showDialogue: () => void } => {
  const history = useHistory();

  const { provideProps, showDialogue } = useConfirmationDialogue();

  useEffect(() => {
    const handlers = {
      default: () =>
        provideProps({
          title: 'Processing ...',
          subTitle: '',
          status: 'alert',
          confirm: {
            label: 'Please wait ...',
            action: () => {},
          },
        }),
      success: () =>
        provideProps({
          title: 'Saved! Your permissions have been updated successfully.',
          subTitle: 'Return to the Accounts page or stay here if you wish to make further updates.',
          status: 'success',
          confirm: {
            label: 'Back to Accounts',
            action: () => {
              history.push('/accounts');
            },
          },
          cancel: {
            label: 'Stay Here',
            action: () => {},
          },
        }),
      error: () => {
        provideProps({
          title: 'Error! Your permissions have not been updated.',
          subTitle: response.errorMessage,
          status: 'error',
          confirm: {
            label: 'Back to Accounts',
            action: () => history.push('/accounts'),
          },
          cancel: {
            label: 'Stay Here',
            action: () => {},
          },
        });
      },
    };

    if (response.success) return handlers.success();

    if (typeof response.errorMessage !== 'undefined' && response.errorMessage !== '') return handlers.error();

    return handlers.default();
  }, [response]);
  return { showDialogue };
};

export default usePermissionUpdateDialogue;
